import { Component } from "react";
import { Card } from "react-bootstrap";
import DocumentsUpload from "./UploadDocs/DocumentsUpload";
import PfUpload from "./UploadDocs/PfUpload";
import ProfileImageUpload from "./UploadDocs/ProfileImageUpload";
import UserIdsUpload from "./UploadDocs/UserIdsUpload";

export default class UploadPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userId: this.props.location.state?.userId || null,
      userName: this.props.location.state?.userName || "Unknown",
    };
  }
  onEmployeeList = () => {
    this.props.history.push('/employee-list')
  }
  render() {
    const { userId } = this.state;

    return (
      <div className=" mt-4">
        <Card>
          <Card.Header>
            <div className="upload-page-heading">
              <b>Upload Profile Image & Documents</b>
              <span style={{ cursor: 'pointer' }} onClick={() => this.onEmployeeList()}>
                <i className="far fa-arrow-alt-circle-right"> Employee List</i> </span>
            </div>
          </Card.Header>
          <Card.Body>
            <ProfileImageUpload userId={userId} />
            <DocumentsUpload userId={userId} />
            <UserIdsUpload userId={userId} />
            <PfUpload userId={userId} />
          </Card.Body>
        </Card>
      </div>
    );
  }
}
